import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { downloadStateAtom } from '../../atoms'

import { formatBytes } from './format-bytes'

export const UpdateDownloadProgress = () => {
  const [downloadState] = useAtom(downloadStateAtom)

  const { contentLength } = downloadState

  const downloaded =
    downloadState._tag === 'DownloadStateInProgress'
      ? downloadState.downloaded
      : 0

  const size =
    (contentLength ? `${formatBytes(contentLength)} / ` : '') +
    formatBytes(downloaded)

  if (downloadState._tag === 'DownloadStateInProgress') {
    return (
      <>
        {contentLength ? (
          <>
            <Progress value={downloaded} max={contentLength} />
            <Percents>{`${((downloaded / contentLength) * 100).toFixed(0)}% `}</Percents>
          </>
        ) : undefined}
        <div>{size}</div>
      </>
    )
  }

  return undefined
}

const Percents = styled.div`
  width: 30px;
  text-align: center;
  color: var(--primary-9);
`

const Progress = styled.progress`
  width: 54px;
  height: 6px;
  appearance: none;
  -webkit-appearance: none;

  &::-webkit-progress-bar {
    background-color: var(--appearance-1);
    border-radius: 3px;
    padding: 2px;
  }

  &::-webkit-progress-value {
    background-color: var(--primary-9);
    border-radius: 2px;
  }

  &::-moz-progress-bar {
    background-color: var(--primary-9);
    border-radius: 2px;
  }
`
